var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"page-header"},[_c('section',{staticClass:"page-title-wrap"},[_c('img',{staticClass:"page-logo",attrs:{"src":_vm.logo}}),_c('img',{staticClass:"page-title",attrs:{"src":_vm.title}})]),_c('img',{staticClass:"page-slogan",attrs:{"src":_vm.slogan}})])
}
var staticRenderFns = []

export { render, staticRenderFns }